import Modal from '../../../shared/Modal';
import InteractionsList from '../InteractionsList';

const InteractionsModal = ({
  open,
  setOpen,
  userFilter,
  logout,
  message
}) => {
  return (
    <Modal
      isOpen={open}
      onClose={() => setOpen(false)}
      title="Historial de actividades"
    >
      <div className="p-8 mt-8 mb-8">
        <InteractionsList
          mode="modal"
          message={message}
          userFilter={userFilter ?? null}
          logout={logout}
        />
      </div>
    </Modal>
  );
};

export default InteractionsModal;
